import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    perPage: Number,
    searchQuery: String,
    searchPath: String
  };
  static targets = ['searchField', 'searchResults'];

  get searchFieldClearIcon() {
    return this.searchFieldTarget.querySelector('.autocomplete-search-clear');
  }

  get searchFieldInput() {
    return this.searchFieldTarget.querySelector('input');
  }

  connect() {
    this.searchQuery = this.searchQueryValue;
    this.perPage = this.perPageValue;
    this.processSearch = this.debounce(() => this.updateContent());
  }

  searchFieldTargetConnected() {
    this.searchFieldClearIcon.addEventListener('click', () => {
      this.searchFieldInput.value = '';
      this.search({ target: { value: '' } });
    });
  }

  // Respond to user typing in search query input.
  search({ target: { value } }) {
    this.searchQuery = value;
    this.updateSearchFieldClearIcon(value);
    this.processSearch();
  }

  updateSearchFieldClearIcon(searchValue) {
    if (searchValue != null && searchValue != '') {
      this.searchFieldClearIcon.classList.remove('hidden');
    } else {
      this.searchFieldClearIcon.classList.add('hidden');
    }
  }

  /*
   * Request search from the server, then re-render content.
   */
  updateContent() {
    if (this.searchQuery == '') {
      this.searchResultsTarget.innerHTML = '';
    } else {
      fetch(this.contentRequest(), this.requestOptions())
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (typeof json.htmlContent !== 'undefined') {
            this.searchResultsTarget.innerHTML = json.htmlContent.list;
          }
        });
    }
  }

  // Return a Request constructed of the search path and full query parameters.
  contentRequest() {
    return new Request(this.searchPathValue + `?${this.queryParams()}`);
  }

  // Combine the different search options into URL parameters.
  queryParams() {
    return [this.searchQueryParam(), this.perPageParam()].join('&');
  }

  searchQueryParam() {
    return `query=${this.searchQuery}`;
  }

  // Return the parameter for the requested number of items per page.
  perPageParam() {
    return `per_page=${this.perPage}`;
  }

  requestOptions() {
    return {
      headers: {
        Accept: 'application/json'
      }
    };
  }

  debounce(func, timeout = 500) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }
}
